import React, { memo } from "react";

function Loader({ variant = "purple" }) {
    return (
        <div className={`c-loader${variant ? ` c-loader--${variant}` : ""}`} />
    );
}

export default memo(Loader);
